export enum PaymentRequestPriorityTypeEnum {
  High=0,
  Average = 1,
  Low = 2,
}

export enum PaymentRequestStatusTypeEnum {
  Confirmed=0,
  NotConfirmed = 1,
  Paid = 2,
  Rejected = 3,
}

export enum AmountTypeEnum {
  Principal = 0,
  PrincipalDebt = 1
}